<script setup>
import {computed} from "vue";

const props = defineProps({
    pagination: {
        required: true,
        type: Object
    }
})

const emit = defineEmits(['changePage'])

const pageLinks = computed(() => {

    let pages = []

    // 3 before
    for (let x = props.pagination.current_page - 3; x < props.pagination.current_page; x++) {
        if (x > 0) pages.push(x)
    }

    // current
    pages.push(props.pagination.current_page)

    // 3 after
    for (let a = props.pagination.current_page + 1; a <= props.pagination.current_page + 3; a++) {
        if (a <= props.pagination.last_page) pages.push(a)
    }

    return pages

})

const showPage = (page) => {
    if (page === props.pagination.current_page) return
    emit('changePage', page)
}

const showPrevious = () => {
    if (props.pagination.current_page <= 1) return
    showPage(props.pagination.current_page - 1)
}

const showNext = () => {
    if (props.pagination.current_page >= props.pagination.last_page) return
    showPage(props.pagination.current_page + 1)
}

const showFirst = () => {
    if (props.pagination.current_page === 1) return
    showPage(1)
}

const showLast = () => {
    if (props.pagination.current_page === props.pagination.last_page) return
    showPage(props.pagination.last_page)
}

</script>

<template>
    <p class="pagination-legend">{{ pagination.from }} - {{ pagination.to }} of {{ pagination.total }}</p>
    <div class="pagination-links">
        <button class="pagination-arrow" @click.prevent="showFirst"
                :class="{'--is-disabled': pagination.current_page === 1}">
            <ah-icon name="arrow-line-left-alt"/>
        </button>
        <button class="pagination-arrow" @click.prevent="showPrevious"
                :class="{'--is-disabled': pagination.current_page === 1}">
            <ah-icon name="arrow-left"/>
        </button>
        <button class="pagination-page" v-for="p in pageLinks" @click.prevent="showPage(p)"
                :class="{'--is-current': p === pagination.current_page}">{{ p }}
        </button>
        <button class="pagination-arrow" @click.prevent="showNext"
                :class="{'--is-disabled': pagination.current_page === pagination.last_page}">
            <ah-icon name="arrow-right"/>
        </button>
        <button class="pagination-arrow" @click.prevent="showLast"
                :class="{'--is-disabled': pagination.current_page === pagination.last_page}">
            <ah-icon name="arrow-line-right-alt"/>
        </button>
    </div>
</template>

<style lang="scss">
.pagination-legend {
    @include font(1.2, null, black);
}

.pagination-links {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: .5rem;

    .pagination-arrow {
        width: 4rem;
        height: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--color-white-100);
        border-radius: 1.5rem;
        fill: var(--color-grey-hazy);
        cursor: pointer;
        transition: all .2s ease;
        border: .2rem solid transparent;

        @include hover() {
            border-color: var(--color-grey-dew);
        }

        @include dark() {
            background: var(--color-darth-maul);

            @include hover() {
                border-color: var(--color-white-20);
            }
        }

        &.--is-disabled {
            opacity: .5;
            border-color: transparent !important;
            cursor: default;
        }

    }

    .pagination-page {
        width: 3rem;
        height: 3rem;
        display: block;
        background: var(--color-white-100);
        border-radius: 1.5rem;
        @include font(1.2, null, black);
        color: var(--color-grey-thunder);
        cursor: pointer;
        border: .2rem solid transparent;
        transition: all .2s ease;

        @include hover() {
            border-color: var(--color-grey-dew);
        }

        &.--is-current {
            background: var(--color-red-raspberry);
            color: #fff;
            border-color: transparent;
            cursor: default;
        }

        @include dark() {
            background: var(--color-darth-maul);
            color: #fff;

            @include hover() {
                border-color: var(--color-white-20);
            }

            &.--is-current {
                background: var(--color-red-raspberry);
                color: #fff;
                border-color: transparent;
                cursor: default;
            }
        }
    }
}
</style>
